angular.module('mymessages').factory('MyMessagesRepository',
    ['AprimaRestangular', function (AprimaRestangular) {
            'use strict';


        //[Route("api/patient/v1/patients/{patientId:Guid}/messages/{messageId:Guid}/messages")]
        function getMessageThreadMessages(userId, messageId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('patients/' + userId + '/messages/' + messageId + '/messages').get();
        }


        //[Route("api/patient/v1/patients/{userId:Guid}/messages")]
        function getMessages(userId, messageFilter) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('patients/' + userId).customGET('messages', messageFilter);
        }

        //  [Route("api/patient/v1/settings/{userId:guid}/message-settings")]
        function getMessageSettings(userId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('settings/' + userId + '/message-settings').get();
        }

        function createMessage(userId, message) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('messages/' + userId + '/create').customPOST(message);
        }

        function replyToMessage(userId, message) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('messages/' + userId + '/reply').customPUT(message);
        }

        return {
            getMessages: getMessages,
            getMessageThreadMessages: getMessageThreadMessages,
            getMessageSettings: getMessageSettings,
            createMessage: createMessage,
            replyToMessage: replyToMessage
        };

    }]);